import { render, staticRenderFns } from "./schema.vue?vue&type=template&id=180da2f6&"
import script from "./schema.vue?vue&type=script&lang=js&"
export * from "./schema.vue?vue&type=script&lang=js&"
import style0 from "./schema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports